import { api } from "../lib/api";

export interface ContentFormatDefinition {
  id: string;
  slug: string;
  name: string;
  description: string | null;
  pillar: string;
  status: "draft" | "active" | "retired";
  output_channels: string[];
  required_inputs: string[];
  required_asset_tags: Record<string, unknown>;
  script_structure: Record<string, unknown>;
  cta_pattern: string | null;
  updated_at: string;
}
export interface ContentBlueprint {
  format_slug: string;
  name: string;
  intent: string;
  hook_caption: string;
  cta_caption: string;
  music: { mood: string; genre: string };
  max_total_sec: number;
  shots: Array<{
    role: "unit" | "amenity" | "exterior" | "neighborhood_garnish";
    min: number; max: number; duration_sec: number;
    caption_templates: string[];
    ken_burns: "in" | "out" | "none";
    audio: "ambient" | "mute";
    transition_after: string;
  }>;
}
export interface ContentLibrarySnapshot {
  schema_version: 1;
  read_only: true;
  fetched_at: string;
  formats_state: "ready" | "unavailable";
  formats: ContentFormatDefinition[];
  format_limit: 500;
  formats_complete: boolean;
  blueprints: ContentBlueprint[];
}
export const contentTemplateLibraryService = {
  async list(): Promise<ContentLibrarySnapshot> {
    const result = await api.get<ContentLibrarySnapshot>("/admin/content/library");
    if (!result || typeof result !== "object" || result.schema_version !== 1 || result.read_only !== true ||
        !Array.isArray(result.formats) || !Array.isArray(result.blueprints) ||
        !["ready", "unavailable"].includes(result.formats_state)) {
      throw new Error("Content template library response is invalid");
    }
    return result;
  },
};
